import { Item, ItemContent, ItemMedia, ItemTitle } from "@/components/ui/item.tsx"
import { Spinner } from "@/components/ui/spinner.tsx"

type LoadingProps = {
  loadingContent?: string
  width?: string
  variant?: "default" | "outline" | "muted"
  size?: "default" | "sm" | "xs"
  spinnerClassName?: string
}

const LoadingSpinner = ({
  loadingContent = "",
  width = "w-full",
  variant = "outline",
  size = "default",
  spinnerClassName = "text-primary",
}: LoadingProps) => {
  return (
    <div className=" flex flex-col justify-center h-full text-muted-foreground">
      <div className={`flex align-middle justify-center ${width}`}>
        <Item size={size} variant={variant} className="w-auto">
          <ItemMedia>
            <Spinner className={`text-primary ${spinnerClassName}`}/>
          </ItemMedia>
          <ItemContent>
            <ItemTitle>{loadingContent}</ItemTitle>
          </ItemContent>
        </Item>
      </div>
    </div>
  )
}

export default LoadingSpinner
